/*
 *
 * ApmConfigurationModal
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 14-Jan-2025
 */

import ApmConfigurationModal from './ApmConfigurationModalContainer'

export default ApmConfigurationModal
